import { preventUnconfirmedFormSubmission } from "./form-confirmation";

/** Wires the shared confirmation behavior to marked forms on one page. */
export class MarkedFormConfirmationController {
  private readonly forms: HTMLFormElement[];

  public constructor(root: HTMLElement) {
    this.forms = Array.from(root.querySelectorAll<HTMLFormElement>("[data-confirm]"));
  }

  public connect(): void {
    for (const form of this.forms) {
      form.addEventListener("submit", preventUnconfirmedFormSubmission);
    }
  }

  public disconnect(): void {
    for (const form of this.forms) {
      form.removeEventListener("submit", preventUnconfirmedFormSubmission);
    }
  }
}
